/* eslint-disable no-console */
import { MedplumClient } from '@medplum/core';
import { Device } from '@twilio/voice-sdk';
import { fetchBot } from './services';

export interface AccountPhoneNumber {
  callerId: string;
  friendlyName: string;
}

export interface TwilioTokenResponse {
  token: string;
  identity: string;
  availableCallerIds: AccountPhoneNumber[];
}

export async function getTwilioToken(medplum: MedplumClient): Promise<TwilioTokenResponse> {
  const response = (await fetchBot(medplum, 'twilio-token', {})) as TwilioTokenResponse;
  return response;
}

interface SetupDeviceParams {
  token: string;
  medplum: MedplumClient;
  onRegistered: () => void;
  onError: (error: any) => void;
  onIncoming: (conn: any) => void;
  onUnregistered: () => void;
}

export async function setupDevice({
  token,
  medplum,
  onRegistered,
  onError,
  onIncoming,
  onUnregistered,
}: SetupDeviceParams): Promise<Device> {
  console.log('setupDevice: Setting up device');

  const device = new Device(token, {
    codecPreferences: ['opus', 'pcmu'] as any,
  });

  device.on(Device.EventName.TokenWillExpire, async () => {
    console.log('Token will expire, refreshing...');
    const tokenResponse = await getTwilioToken(medplum);
    device.updateToken(tokenResponse.token);
  });

  device.on(Device.EventName.Registered, function () {
    console.log('Twilio.Device Ready to make and receive calls!');
    onRegistered();
  });

  device.on(Device.EventName.Unregistered, function () {
    console.log('Twilio.Device Unregistered');
    onUnregistered();
  });

  device.on(Device.EventName.Error, async function (error) {
    console.log('Twilio.Device Error: ' + error.message);

    if ([20104, 20101].includes(error.code)) {
      try {
        const tokenResponse = await getTwilioToken(medplum);
        device.updateToken(tokenResponse.token);
        if (device.state === Device.State.Unregistered) {
          return await device.register();
        }
      } catch (refreshError) {
        console.error('Failed to refresh expired Twilio token:', refreshError);
        onError(error);
      }

      return;
    }
    onError(error);
  });

  device.on(Device.EventName.Incoming, async function (conn) {
    console.log('Incoming connection from ' + conn.parameters.From);
    onIncoming(conn);
  });

  return device;
}
